import React from 'react';
import ReactDOM from "react-dom";
import { Sparkle } from 'lucide-react';
import CloseButton from 'components/ui/close-button';


const UseExistingTemplateModal = ({ setShowUseTemplateModal, filteredAllTemplates, handlePreviewClick, setSearchTerm, searchTerm, customTemplateUpdation }) => {
  return (
    <div>
      {ReactDOM.createPortal(
        <div className={`fixed inset-0 bg-ink bg-opacity-70 z-[88]`} />,
        document.body
      )}

      {ReactDOM.createPortal(
        <div className="fixed inset-0 z-[90] flex items-center justify-center p-4 pointer-events-none">
        <div
          className="pointer-events-auto flex h-[80vh] w-[90vw] max-w-[700px] flex-col rounded-ns border border-solid border-rule bg-shade-50 p-4 shadow-pop sm:w-[70vw]"
        >
          {/* The title was centred with `mx-auto pl-9` — a hand-tuned offset for
              the close button's width, which breaks the moment either changes.
              A spacer of the button's own size does the same job honestly. */}
          <div className="mb-3 flex w-full items-center justify-between gap-2">
            <span className="h-8 w-8 flex-shrink-0" aria-hidden="true" />
            <p className="truncate font-display text-ui-lg font-medium text-ink">
              Choose From Existing Template
            </p>
            <CloseButton onClick={() => setShowUseTemplateModal(false)} />
          </div>

          <div className="flex h-[50vh] w-full flex-1 flex-col rounded-ns border border-solid border-rule bg-white p-4">
            <input
              type="text"
              placeholder="Search templates..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="mt-2 w-full rounded-ns border border-solid border-rule-strong px-3 py-2 font-body text-ui-sm text-ink outline-none transition-colors duration-ui ease-ui focus:border-accent focus:ring-1 focus:ring-accent"
            />

            <p className="mt-4 rounded-ns border-b border-solid border-rule bg-shade-50 px-2 py-2 font-display text-ui-md font-medium text-ink">
              Recommended Templates
            </p>

            <div className="mt-2 overflow-y-auto flex-1">
              {filteredAllTemplates.length === 0 ? (
                <div className="text-center py-4 text-muted">No templates found</div>
              ) : (
                filteredAllTemplates.map((template, i) => (
                  <div
                    key={i}
                    className={`mx-auto cursor-pointer hover:bg-shade-50 
                                w-full sm:w-full max-w-full 
                                flex flex-col sm:flex-row justify-between items-start sm:items-center 
                                py-3 px-1 sm:py-4 sm:px-1 gap-3 sm:gap-0 
                                ${i !== filteredAllTemplates.length - 1 ? 'border-b' : ''}`}
                  >
                    <p className="text-sm sm:text-base p-1">{template.name}</p>

                    <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                      <button
                        className="w-full rounded-ns bg-accent px-6 py-2 font-body text-ui-xs font-semibold text-white transition-colors duration-ui ease-ui hover:bg-deep active:scale-[.98] sm:w-auto"
                        onClick={(e) => customTemplateUpdation(e, template.id)}
                      >
                        Select
                      </button>

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePreviewClick(template);
                        }}
                        className="flex w-full items-center justify-center gap-1.5 rounded-ns border border-solid border-rule-strong bg-white px-3 py-[6px] font-body text-ui-xs font-semibold text-accent transition-colors duration-ui ease-ui hover:border-accent hover:bg-accent-tint sm:w-auto sm:justify-start"
                      >
                        <Sparkle size={14} />
                        Preview
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        </div>,
        document.body
      )}
    </div>
  )
}

export default UseExistingTemplateModal